import {
  CSSProperties,
  Dispatch,
  SetStateAction,
  useEffect,
  useState,
} from "react";

import { FileInterface } from "../../../../../types/RecordInterfaces";
import { FileSources } from "../../../../../types/FileInterfaces";
import { uploadImage } from "../../../../../utils/GeneralUtils";
import IconButton from "../../../../../elements/IconButton";
import TenantAPI from "../../../../../api/api/TenantAPI";
import FileDnd from "./FileDnd";

interface IFileHandler {
  file: FileInterface | null;
  setFile: Dispatch<SetStateAction<FileInterface | null>>;
  handleFileData?: (file: FileUpload) => void;
  /** To use the Global container */
  publicContainer: boolean;
  style?: CSSProperties;
  sources?: FileSources[];
  recordID: string;
  moduleAPIName: string;
  fieldAPIName: string;
}

interface FileUpload {
  fileName: string;
  url: string;
  files: FileInterface[];
}

const FileHandler = ({
  file,
  setFile,
  handleFileData,
  publicContainer = false,
  style,
  sources = [],
  recordID,
  moduleAPIName,
  fieldAPIName,
}: IFileHandler) => {
  const [uploading, setUploading] = useState(false);
  const [urlFile, setURLFile] = useState("");

  useEffect(() => {
    if (file && !urlFile) {
      getFileURL();
    }
  }, [file]);

  const getFileURL = async () => {
    if (!file) return;

    let fileURL = file?.PublicURL;

    if (!fileURL) {
      const fileURLResponse = await TenantAPI.getFileURL(
        file?.File,
        undefined,
        publicContainer
      );
      fileURL = fileURLResponse?.data?.data?.url;
    }

    if (fileURL) setURLFile(fileURL);
  };

  const handleUploadFile = async (e: any) => {
    setUploading(true);

    const data = await uploadImage(
      e.target.files[0],
      true,
      true,
      publicContainer,
      sources
    );

    if (typeof data === "string") return;

    setFile(data.files[0]);
    setURLFile(data.url);
    handleFileData && handleFileData(data);

    setUploading(false);
  };

  const handleRemoveFile = async () => {
    if (!file) return;

    let blob = file.File;

    if (blob.includes("https")) {
      const index = blob.indexOf("uploaded_files/");

      if (index) blob = blob.slice(index);
    }

    try {
      if (blob) {
        await TenantAPI.deleteFiles({
          type: "blobName",
          blobName: blob,
          moduleAPIName,
          recordID,
          fieldAPIName,
        });
      }
    } catch (error) {}

    handleFileData && handleFileData({ fileName: "", url: "", files: [] });

    setFile(null);
  };

  return (
    <>
      {file && urlFile ? (
        <div className="tw:flex tw:items-start tw:pb-6">
          <img
            src={urlFile}
            alt="Cover Image"
            style={
              style
                ? style
                : {
                    width: "50%",
                    height: "150px",
                    objectFit: "cover",
                    objectPosition: "50% 50%",
                  }
            }
          />
          <IconButton
            icon="delete-outline"
            size="md"
            color="primary"
            className="btn-icon-only tw:ml-3"
            onClick={handleRemoveFile}
          />
        </div>
      ) : (
        <FileDnd upload={handleUploadFile} uploading={uploading} />
      )}
    </>
  );
};

export default FileHandler;
